import { GeoJson } from '@ais-ui/api-spec/shapes';
import VectorLayer from 'ol/layer/Vector';
import { shapeToFeature } from './shapeToFeature';
import VectorSource from 'ol/source/Vector';
import { getFeatureStyle } from '../styles/getStyle';
import Feature, { FeatureLike } from 'ol/Feature';
import type OlGeometry from 'ol/geom/Geometry';
import { HeatmapConfig } from '@ais-ui/basecolours';
import { feature } from '@turf/turf';

export const shapeToVectorLayer = (
  shape: GeoJson | undefined | null,
  timeZone?: string
): VectorLayer<Feature<OlGeometry>> => {
  const vectorSource = new VectorSource<Feature<OlGeometry>>();

  if (shape?.type === 'FeatureCollection' && shape.features) {
    shape.features.forEach((featureShape) => {
      const feature = shapeToFeature(featureShape); // should return Feature<OlGeometry>
      if (feature?.getGeometry()) {
        vectorSource.addFeature(feature);
      }
    });
  } else {
    const feature = shapeToFeature(shape);
    if (feature?.getGeometry()) {
      vectorSource.addFeature(feature);
    }
  }

  const color = shape?.properties?.color || 'blue';
  const showLabel = !!shape?.properties?.showLabel;
  const transparency = shape?.properties?.transparency ?? 0.4;
  const heatmapConfig: HeatmapConfig = shape?.properties?.heatmapConfig;

  const styleFunction = (feature: FeatureLike) => {
    return getFeatureStyle(
      feature,
      color,
      'medium',
      'medium',
      showLabel,
      transparency,
      timeZone,
      heatmapConfig
    );
  };

  return new VectorLayer({
    source: vectorSource,
    style: styleFunction,
  });
};
